module.exports = __webpack_public_path__ + "static/locales/en.1Nz2HPg.json";